import React from 'react';

interface LiquidCardProps {
  children: React.ReactNode;
  className?: string;
}

export const LiquidCard = ({ children, className = '' }: LiquidCardProps) => {
  return (
    <div
      className={`
        liquid-glass 
        rounded-lg 
        overflow-hidden 
        transition-all 
        duration-500 
        hover:scale-[1.03] 
        hover:shadow-2xl 
        hover:shadow-primary-500/20
        ${className}
      `}
    >
      {children}
    </div>
  );
};
